

export default function Sample2() {
    return(
        <>
            Please refresh your browser.
        </>
    );
}